import { ResultType } from "./resultType"

export const ALL = process.env.REACT_APP_HK01_ARTICLE_INDEX_NAME as string
export const ARTICLES = process.env.REACT_APP_HK01_ARTICLE_INDEX_NAME as string
export const ISSUES = process.env.REACT_APP_HK01_ISSUE_INDEX_NAME as string
export const VIDEO = process.env.REACT_APP_HK01_ARTICLE_INDEX_NAME as string
export const COUPONS = process.env.REACT_APP_HK01_COUPON_INDEX_NAME as string

const indexes = process.env.REACT_APP_HK01_INDEXES_SHOW

export const INDEXES = ((indexes && indexes.split(",")) || []) as ResultType[]
